import { render, staticRenderFns } from "./change-indexer.vue?vue&type=template&id=6885b38d&scoped=true&"
import script from "./change-indexer.vue?vue&type=script&lang=js&"
export * from "./change-indexer.vue?vue&type=script&lang=js&"
import style0 from "./change-indexer.vue?vue&type=style&index=0&id=6885b38d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6885b38d",
  null
  
)

export default component.exports